import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {FormattedMessage, useIntl} from "react-intl";

import Button from "@mui/material/Button";

import {downloadImageWithFetch} from "../../../../misc/misc2";
import LookBeforeAfterSlider from "./LookBeforeAfterSlider";
import {loadImagePromise} from "../../../../misc/offlineImagesCache";
import LoadingSpinner from "../../../ui/loadingSpinner";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";


const LookAIImageOverlayImageContent = (props) => {

  const {aiResults, aiUserFileBlobUrl, opened, closeAIImageOverlay} = props;
  const [imagesLoaded, setImagesLoaded] = useState([]);

  const intl = useIntl();

  const activeResult = aiResults.find(aiResult => aiResult.isActive);
  const imageLoaded = activeResult ? imagesLoaded.includes(activeResult.resultImageUrl) : false;

  useEffect(() => {
    const loaded = activeResult ? imagesLoaded.includes(activeResult.resultImageUrl) : false;
    if (!loaded) {
      const loadImages = async () => {
        await loadImagePromise(activeResult.resultImageUrl);
        setImagesLoaded([...imagesLoaded, activeResult.resultImageUrl]);
      }
      loadImages();
    }
  }, [imagesLoaded, activeResult]);

  if (!activeResult) {
    return null;
  }

  return (
    <div className="flex--1 relative w-full h-full rounded-025 overflow-hidden">
      <picture>
        {/*<source srcSet={activeResult.resultImageUrl} media="(min-width: 600px)"/>*/}
        <img className={imageLoaded ? "" : "opacity-0 visibility-hidden"}
             src={activeResult.resultImageUrl} alt="Your Generated Design"/>
      </picture>
      {imageLoaded ? <LookBeforeAfterSlider
        opened={opened}
        backgroundImageUrl={activeResult.sourceImageUrl || aiUserFileBlobUrl}
        overlayImageUrl={activeResult.resultImageUrl}
      /> : (
        <div
          className="rounded-025 absolute left-0 top-0 w-full h-full overflow-hidden flex flex--center">
          <LoadingSpinner/>
        </div>
      )}
      <Button className="look-ai__overlay-download-button pl-2 pr-2 right-1 bottom-1 nowrap"
              onClick={() => downloadImageWithFetch(activeResult.resultImageUrl, "visualizer.png")}>
        <FormattedMessage id="look.ai.overlay.downloadImageButton"/>
      </Button>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                  className="look-icon look-icon--small look-icon--white2 rounded-full absolute z-10 top-075 right-075"
                  onClick={closeAIImageOverlay}>
        <CloseIcon/>
      </IconButton>
    </div>
  )

};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {aiUserFileBlobUrl, aiResults} = store.aiState;

  return {
    aiResults,
    lookOverlayOpened,
    aiUserFileBlobUrl,
  };
};


export default connect(mapStateToProps)(LookAIImageOverlayImageContent)
